import { IFileTypeConfig } from '@shared/ui-components/au-file-loader/au-file-loader.interfaces';

export const fileTypesConfig: IFileTypeConfig = {
	image: {
		// list of formats after the dot - image.JPEG, image.PNG, etc
		supportedFormatsList: ['gif', 'jpg', 'jpeg', 'png', 'webp'],
		// in megabytes
		maxSize: 30,
		// icon name from for mat-icon
		icon: 'file-image',
	},
	iosImage: {
		supportedFormatsList: ['heic', 'heif'],
		maxSize: 30,
		icon: 'file-image',
	},
	video: {
		supportedFormatsList: ['mp4', 'hevc', 'avi', 'm4v', 'mov', 'webm', 'mpeg', 'mkv'],
		maxSize: 2000,
		icon: 'file-video',
	},
	msword: {
		supportedFormatsList: ['doc', 'docx', 'odt', 'odp', 'rtf'],
		maxSize: 40,
		icon: 'file-msword',
	},
	odp: {
		supportedFormatsList: ['odp'],
		maxSize: 100,
		icon: 'file-msword',
	},
	exel: {
		supportedFormatsList: ['xls', 'xlsx', 'csv'],
		maxSize: 40,
		icon: 'file-exel',
	},
	csv: {
		supportedFormatsList: ['csv'],
		maxSize: 6,
		icon: 'file-exel',
	},
	txt: {
		supportedFormatsList: ['txt'],
		maxSize: 6,
		icon: 'file-document',
	},
	ods: {
		supportedFormatsList: ['ods'],
		maxSize: 40,
		icon: 'file-document',
	},
	pdf: {
		supportedFormatsList: ['pdf'],
		maxSize: 100,
		icon: 'file-pdf',
	},
	presentation: {
		supportedFormatsList: ['ppt', 'pptx'],
		maxSize: 100,
		icon: 'file-presentation',
	},
	cad: {
		supportedFormatsList: ['dwg'],
		maxSize: 100,
		icon: 'file-cad',
	},
	scan3d: {
		supportedFormatsList: ['gltf', 'glb'],
		maxSize: 100,
		icon: 'file-3d-scan',
	},
	bim: {
		supportedFormatsList: ['ifc'],
		maxSize: 500,
		icon: 'file-bim',
	},
	floorPlanImage: {
		supportedFormatsList: ['jpg', 'jpeg', 'png'],
		maxSize: 30,
		icon: 'file-image',
	},
	floorPlan: {
		supportedFormatsList: ['dxf'],
		maxSize: 100,
		icon: 'file-floor-plan',
	},
	zip: {
		supportedFormatsList: ['zip'],
		maxSize: 100,
		icon: 'file-floor-plan',
	},
};
